import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
function Academic() {
  const data = [
    {
      name: "GAPUROV RUSTAM RAIMDJONOVICH ",
      skill: "Ijrochi direktor ",
      mail: "GAPUROVRUSTAM@mail.ru",
      img: "/img/rustamgapurov.png",
      phone: "71. 207-33-53"
    },
    {
      name: "YERALIYEVA ZULFIYA MAXMUDOVNA ",
      skill: "Yoshlar bilan ishlash bo’yicha direktor o’rinbosari",
      mail: "YERALIYEVAZULFIYA@mail.ru",
      img: "/img/zulfiyayeraliyeva.png",
      phone: "90. 349-52-34"
    },
    {
      name: "QILICHEV ILXOM SAYDAKBARXONOVICH ",
      skill: " O’quv ishlari bo’yicha direktor o’rinbosari ",
      mail: "QILICHEV@mail.ru",
      img: "/img/ilxomqilichev.png",
      phone: " 98. 177-25-27 "
    },
    {
      name: "BAZAROV FATXULLA RUBDULLAYEVICH    ",
      skill: "O’quv ishlari bo’yicha direktor o’rinbosari ",
      mail: "BAZAROV@mail.ru",
      img: "/img/fatxullabazarov.png",
      phone: "90. 931-83-93"
    },
  ];
  return (
    <div>
      <Navbar />
      <div className="custom__page">
        <div className="container">
          <div className="card1__custom">
            <div className="header__custom">
              <h4 style={{ marginBottom: "1vw" }}>
                Akademik litsey haqida ma’lumot
              </h4>
              {data.map((item) => (
                <div className="card__custom">
                  <div className="box__custom">
                    <img src={item.img} alt />
                  </div>
                  <div className="box-1__custom">
                    <p> {item.name} </p>
                    <span> {item.skill} </span>
                    <br />
                    <br />
                    <hr />
                    <div className="wer__custom">
                      <div className="malinki__custom">
                        <p>E-pochta</p>
                        <span>{item.mail}</span>
                      </div>
                      <div className="malinki1__custom">
                        <p>Telefon nomer</p>
                        <span>{item.phone} </span>
                      </div>
                    </div>
                    <div className="wer__custom"></div>
                  </div>
                </div>
              ))}
            </div>
            <br />
            <br />
            <p>
              Toshkent farmatsevtika instituti akademik litseyi 2007-yilda
              O`zbekiston Respublikasi Prezidentining 633-sonli qarori va
              O`zbekiston Respublikasi O`rta maxsus, kasb-hunar ta`lim
              markazining 106-sonli buyrug`i asosida tashkil etilgan.
            </p>

            <p>
              Akademik litseyi tabiiy fanlar-1 (kimyo, biologiya) yo’nalishi
              bo’yicha ta’lim bermoqda. Hozirgi kunda litseyida jami 302 nafar
              o’quvchi tahsil olmoqda. Ulardan, 157 nafari – 1-kursda, 145
              nafari – 2-kursda o’qimoqda.
            </p>

            <p>
              Akademik litseyda jami 23 nafar yuqori malakali o’qituvchi
              faoliyat ko’rsatmoqda. Ulardan, 2 nafari – fan nomzodi, 2 nafari –
              bosh o’qituvchi, 6 nafari – etakchi o’qituvchi, 3 nafari – katta
              o’qituvchi va 10 nafari – oliy ma’lumotli o’qituvchilar.
            </p>

            <p>
              Litseyimizda o’quvchilarning bo’sh vaqtlarini mazmunli tashkil
              etish maqsadida 22ta fan, 4 badiiy xavaskorlik va 3ta sport
              to’garaklar tashkil etilgan. Akademik litsey bitiruvchilarga
              ta’lim yo’nalishi bo’yicha davlat namunasidagi diplom va ‘kimyo
              laboranti’ kasbi bo’yicha (laborant sifatida ishlash huquqi bilan)
              sertifikat beriladi.
            </p>

            <p>
              Akademik litseyiga 9-sinf iqtidorli bitiruvchilar tanlov asosida
              o’qishga qabul qilinadi. Litseyda, maktab o’quvchilari uchun
              tayorlov kurslari tashkil etilgan.
            </p>
            <p>
              Litseyda ta`lim o`zbek va rus tillarida olib boriladi. O’qish
              muddati – 2 yil.
            </p>
            <p>
              <b> Manzilimiz</b>: Toshkent shahar, Olmazor tumani, Qora-Qamish
              2/5, 17a uy. <br /> <b>Mo’ljal: </b> Toshkent farmatsevtika
              instituti binosi. Aloqa telefoni: 71. 207-33-53
            </p>
          </div>

          <div className="card5__custom">
            <img src="img/5.png" alt />
            <img src="img/5.png" alt />
            <img src="img/5.png" alt />
          </div>
        </div>
      </div>
      <div className="mt"></div>
      <Footer />
    </div>
  );
}

export default Academic;
